module.exports = __webpack_public_path__ + "img/user.4d04744a.png";